<script>
export default {
    name: 'AtomLoadingRipple',
    
    // 函数组件不会主动支撑组件上定义的class值
    // functional: true,
    
    render(h){
        return h('i', {
            class: ['atom-loading-ripple', `atom-loading-ripple--${this.type}`]
        })
    },

    props: {
        type: {
            type: String,
            default: 'primary'
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/packages/Loading/Core/Ripple.vue